import styled from 'styled-components';

import { BLACK, PAGE_WIDTH, WHITE } from '../../../styles/variables.style';
import media from '../../../styles/media.style';

const STEP_BACKGROUND_COLOR = '#989ea2';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  flex-direction: column;
  max-width: ${PAGE_WIDTH}px;
  height: 100%;
  min-height: 100vh;
  margin: 0 auto;
`;
export const ContentContainer = styled.div`
  flex: 1;
  flex-grow: 1;
  width: calc(100% - 40px);
  height: 100%;
  margin: 30px 20px 0px 20px;
  padding: 40px 0px 24px 0px;

  ${media.tabletP`
    width: 720px;
    margin: 60px auto 0px auto;
  `};
`;
export const TitleText = styled.div`
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  color: ${BLACK};
  padding: 15px 0 20px 0;
  margin-bottom: 15px;

  ${media.tabletP`
    font-size: 30px;
    padding: 15px;
  `};
`;
export const DescriptionText = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${BLACK};
  text-align: center;
  margin-bottom: 20px;
  padding: 0 50px;

  ${media.tabletP`
    font-size: 18px;
    margin-bottom: 30px;
  `};
`;
export const ProgramDetailImage = styled.div`
  width: 100%;
  height: ${({ height }) => height || '108px'};
  box-shadow: 0px 2px 9px 1px rgba(0, 0, 0, 0.15);

  ${media.tabletP`
    width: 720px;
    height: 234px;
  `};
`;
export const ProgramDetailStepsContainer = styled.div`
  flex: 1;
  flex-grow: 1;
  background-color: ${WHITE};
  box-shadow: 0px 2px 9px 1px rgba(0, 0, 0, 0.15);
  ${media.tabletP`
    margin-bottom: 100px;
  `};

  .programbar {
    counter-reset: step;
    margin-left: 0px;
    width: 100%;
    height: 100%;
    background-color: ${WHITE};
    overflow: hidden;
    position: relative;
  }

  .programbar:after {
    width: 4px;
    height: 100%;
    content: '';
    position: absolute;
    border-right: 4px dotted #cccccc;
    top: 0;
    left: -9px;
    margin: 0 0 0 46px;
    z-index: 0;

    ${media.tabletP`
      left: 27px;
    `};
  }

  .programbar li {
    list-style-type: none;
    width: 100%;
    float: left;
    font-size: 18px;
    position: relative;
    color: ${WHITE};
    padding-right: 20px;
    background-color: ${WHITE};

    ${media.tabletP`
      padding-right: 55px;
    `};
  }

  ._programbar li:before {
    width: 58px;
    height: 58px;
    content: counter(step);
    counter-increment: step;
    font-size: 20px;
    line-height: 58px;
    background-color: ${STEP_BACKGROUND_COLOR};
    color: ${WHITE};
    display: block;
    text-align: center;
    margin: 0 auto 0 46px;
    border-radius: 50%;
    border: 2px solid ${STEP_BACKGROUND_COLOR};
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%) ;
    z-index: 3;
  }

  .programbar li:first-child:after {
    width: 4px;
    height: 50%;
    content: '';
    position: absolute;
    border-right: 6px solid ${WHITE};
    top: -40px;
    left: -9px;
    margin: 0 0 0 46px;
    z-index: 2;

    ${media.tabletP`
      top: -20px;
      left: 27px;
    `};
  }
  .programbar li:last-child:after {
    width: 4px;
    height: 100%;
    content: '';
    position: absolute;
    border-right: 6px solid ${WHITE};
    top: 22px;
    left: -9px;
    margin: 0 0 0 46px;
    z-index: 2;

    ${media.tabletP`
      top: 62px;
      left: 27px;
    `};
  }
  .programbar li.active {
    color: ${BLACK};
  }
  ._programbar li.active:before {
    background-color: ${WHITE}
    color: ${BLACK}
  }
  .programbar li.active:after {
    background-color: ${BLACK}
  }
`;
export const ProgramDetailStepsWrapper = styled.div`
  padding-bottom: 50px;
`;
export const ProgramDetailStepContent = styled.div``;
export const ProgramDetailStepWrapper = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 150px;
`;
export const ProgramDetailStepItem = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: left;
  width: calc(100% - 97px);
  min-height: 150px;
  padding: 38px 0 20px;
  border-bottom: 1px solid #d7d7d7;

  ${media.tabletP`
    display: table;
    flex-direction: unset;
    align-items: center;
    width: calc(100% - 140px);
  `};
`;
export const ProgramDetailStepItemContainer = styled.div`
  display: table-cell;
  text-align: left;
  vertical-align: middle;
`;
export const ProgramDetailStepItemContainer2 = styled.div`
  display: table-cell;
  text-align: left;
  vartical-align: middle;
  max-width: 240px;
  margin-top: 20px;

  ${media.tabletP`
    text-align: right;
    max-width: 400px;
    margin-top: 0;
  `};
`;
export const ProgramDetailStepIcon = styled.div`
  width: 40px;
  height: 40px;
  content: counter(step);
  counter-increment: step;
  font-size: 18px;
  line-height: 40px;
  background-color: ${STEP_BACKGROUND_COLOR};
  color: ${WHITE};
  display: block;
  text-align: center;
  border-radius: 50%;
  border: 2px solid ${STEP_BACKGROUND_COLOR};
  position: absolute;
  top: 44px;
  left: 112px;
  transform: translate(-93px, -50%);
  z-index: 3;

  ${media.tabletP`
    width: 58px;
    height: 58px;
    font-size: 20px;
    line-height: 58px;
    top: 50%;
    left: 140px;
  `};
`;
export const ProgramDetailStepIconWrapper = styled.div`
  width: 77px;
  min-height: 150px;

  ${media.tabletP`
    width: 140px;
  `};
`;
export const ProgramDetailStepItemTitleText = styled.div`
  font-size: 14px;
  line-height: 16px;
  height: 16px;
  font-weight: 500;
  color: ${BLACK};
  margin-bottom: 0;

  ${media.tabletP`
    font-size: 18px;
    line-height: 20px;
    height: 20px;
    margin-bottom: 5px;
  `};
`;
export const ProgramDetailStepItemTitleCaption = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${BLACK};
  margin-bottom: 5px;
`;
export const ProgramDetailStepItemLinkText = styled.div`
  margin-top: 14px;
  font-size: 14px;
  font-weight: 500;
  color: ${BLACK};
  text-decoration: underline;

  ${media.tabletP`
    margin-top: 19px;
  `};
`;
export const ProgramDetailStepItemImageContainer = styled.div`
  display: inline-block;
  width: calc(100% * 0.5);
  vertical-align: top;

  ${media.tabletP`
    width: 100px;
  `};
`;
export const ProgramDetailStepItemImage = styled.div`
  margin-left: 0;
  width: 100%;
  height: 70px;

  ${media.tabletP`
    margin-left: 15px;
    width: 70px;
  `};
`;
export const ProgramDetailStepItemImageTitle = styled.div`
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
  color: ${BLACK};
  text-align: center;
  padding: 5px;

  ${media.tabletP`
    font-size: 12px;
    text-align: left;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SalonProgramDetailPage/SalonProgramDetailPage.style.js